import * as React from 'react';

import { SurveyQuestion, SurveyQuestionProps } from './SurveyQuestion';

export interface TypeSubQuestionProps extends SurveyQuestionProps {}

/**
 * @name TypeSubQuestion
 * @description This question type is used to group other questions
 * into a single page/slide based on our question type abstraction(s).
 */
export const TypeSubQuestion = (props: TypeSubQuestionProps) => {
  const { question } = props;

  // const [errorMessage, setErrorMessage] = React.useState('');
  // const { email } = useRecoilValue(userAtom);
  // const { signOut } = useFirebase();

  // Setup
  const { sub_questions: questions = [] } = question;

  return (
    <div className="flex flex-col gap-2">
      {/* <AppErrorMessage className="mb-2x text-red" message={errorMessage} />
      {!email ? (
        <>
          <SignInGoogle
            bordersX="pine"
            className="w-full bg-white"
            setErrorMessage={setErrorMessage}
          />
          <SignInFacebook
            bordersX="pine"
            className="w-full bg-white"
            setErrorMessage={setErrorMessage}
          />
        </>
      ) : (
        <HaldiButton
          className={classnames(
            'text-center mx-auto flex justify-center items-center w-full'
          )}
          bordersX="pine"
          onClick={() => signOut(false)}
        >
          Change email address
        </HaldiButton>
      )}
      <h1 className="mt-3x mb-4x mx-auto w-full text-center border-0 border-b-[1px] border-solid border-b-gray-5 leading-[0px]">
        <span className="text-14 text-gray-5 bg-turmeric px-1x">OR</span>
      </h1> */}

      {questions.map((q) => {
        if (!q) return null;
        return <SurveyQuestion key={q.id} question={q} />;
      })}
    </div>
  );
};
